/** Skeleton placeholder for the student home page while cohort membership loads. */
export function StudentHomeSkeleton() {
  return (
    <main className="page page-align-start student-page-inner" aria-busy="true" aria-label="Loading your home page">
      <div className="card card-wide">
        <header className="row-header">
          <div className="student-home-skeleton-header">
            <div className="skeleton skeleton--eyebrow" />
            <div className="skeleton skeleton--title" />
            <div className="skeleton skeleton--lede" />
          </div>
        </header>

        <section className="panel student-progress-callout student-home-skeleton-callout">
          <div className="skeleton skeleton--panel-title" />
          <div className="student-up-next-row">
            <div className="skeleton skeleton--lesson-icon" />
            <div className="student-home-skeleton-up-next">
              <div className="skeleton skeleton--line skeleton--line-lg" />
              <div className="skeleton skeleton--line skeleton--line-md" />
              <div className="skeleton skeleton--button" />
            </div>
          </div>
        </section>

        <section className="panel">
          <div className="skeleton skeleton--panel-title" />
          <div className="skeleton skeleton--input" />
        </section>

        <section className="panel">
          <div className="skeleton skeleton--panel-title skeleton--panel-title-wide" />
          <div className="student-home-skeleton-lessons">
            {[0, 1, 2].map((i) => (
              <div key={i} className="student-home-skeleton-lesson-row">
                <div className="skeleton skeleton--lesson-icon skeleton--lesson-icon-sm" />
                <div className="student-home-skeleton-lesson-copy">
                  <div className="skeleton skeleton--line skeleton--line-lg" />
                  <div className="skeleton skeleton--line skeleton--line-sm" />
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
